import { render, staticRenderFns } from "./biu-tree.vue?vue&type=template&id=b8283470&"
import script from "./biu-tree.vue?vue&type=script&lang=ts&"
export * from "./biu-tree.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports